import { render, staticRenderFns } from "./InSalonClasses.vue?vue&type=template&id=03a5a76a&"
import script from "./InSalonClasses.vue?vue&type=script&lang=js&"
export * from "./InSalonClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports